import * as Assets from '~/models/Asset'
import { SOURCE_FILE_TYPES } from '~/enums'

export function getFileTypeByAsset(asset) {
  if (asset instanceof Assets.VideoAsset
    || asset instanceof Assets.ImageAsset
    || asset instanceof Assets.AudioAsset) {
    return SOURCE_FILE_TYPES.MEDIA
  }

  if (asset instanceof Assets.TextAsset) {
    return SOURCE_FILE_TYPES.TEXT
  }

  // http://18.184.210.86/issues/1975
  // if (asset instanceof Assets.AudioAsset) {
  //   return SOURCE_FILE_TYPES.AUDIO
  // }

  if (asset instanceof Assets.TransitionAsset) {
    return SOURCE_FILE_TYPES.TRANSITIONS
  }

  // TODO: filters/design

  throw new Error(`Unsupported asset type ${asset.constructor.name}`)
}
